/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserIdentityProvider } from './UserIdentityProvider';
import {
    UserIdentityProviderFromJSON,
    UserIdentityProviderFromJSONTyped,
    UserIdentityProviderToJSON,
    UserIdentityProviderToJSONTyped,
} from './UserIdentityProvider';
import type { UserKrrInfoResponse } from './UserKrrInfoResponse';
import {
    UserKrrInfoResponseFromJSON,
    UserKrrInfoResponseFromJSONTyped,
    UserKrrInfoResponseToJSON,
    UserKrrInfoResponseToJSONTyped,
} from './UserKrrInfoResponse';
import type { UserOrganizationGroupResponse } from './UserOrganizationGroupResponse';
import {
    UserOrganizationGroupResponseFromJSON,
    UserOrganizationGroupResponseFromJSONTyped,
    UserOrganizationGroupResponseToJSON,
    UserOrganizationGroupResponseToJSONTyped,
} from './UserOrganizationGroupResponse';
import type { ExternalUserStatus } from './ExternalUserStatus';
import {
    ExternalUserStatusFromJSON,
    ExternalUserStatusFromJSONTyped,
    ExternalUserStatusToJSON,
    ExternalUserStatusToJSONTyped,
} from './ExternalUserStatus';
import type { UserAliasResponse } from './UserAliasResponse';
import {
    UserAliasResponseFromJSON,
    UserAliasResponseFromJSONTyped,
    UserAliasResponseToJSON,
    UserAliasResponseToJSONTyped,
} from './UserAliasResponse';

/**
 * 
 * @export
 * @interface ExternalUserDetailResponse
 */
export interface ExternalUserDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    mfaPhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalUserDetailResponse
     */
    isIdPortenUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalUserDetailResponse
     */
    isIdPortenValidated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ExternalUserDetailResponse
     */
    lastLoggedInOn?: Date | null;
    /**
     * 
     * @type {Array<UserAliasResponse>}
     * @memberof ExternalUserDetailResponse
     */
    userAliases?: Array<UserAliasResponse> | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    organizationAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    organizationForm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    organizationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    organizationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalUserDetailResponse
     */
    organizationPostNumberAndCity?: string | null;
    /**
     * 
     * @type {ExternalUserStatus}
     * @memberof ExternalUserDetailResponse
     */
    status?: ExternalUserStatus;
    /**
     * 
     * @type {UserIdentityProvider}
     * @memberof ExternalUserDetailResponse
     */
    identityProvider?: UserIdentityProvider;
    /**
     * 
     * @type {UserKrrInfoResponse}
     * @memberof ExternalUserDetailResponse
     */
    userKrrInfo?: UserKrrInfoResponse;
    /**
     * 
     * @type {UserOrganizationGroupResponse}
     * @memberof ExternalUserDetailResponse
     */
    statsforvalterenOrganizationGroup?: UserOrganizationGroupResponse;
}



/**
 * Check if a given object implements the ExternalUserDetailResponse interface.
 */
export function instanceOfExternalUserDetailResponse(value: object): value is ExternalUserDetailResponse {
    return true;
}

export function ExternalUserDetailResponseFromJSON(json: any): ExternalUserDetailResponse {
    return ExternalUserDetailResponseFromJSONTyped(json, false);
}

export function ExternalUserDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'mfaPhoneNumber': json['mfaPhoneNumber'] === undefined ? undefined : json['mfaPhoneNumber'] === null ? null : json['mfaPhoneNumber'],
        'isIdPortenUser': json['isIdPortenUser'] == null ? undefined : json['isIdPortenUser'],
        'isIdPortenValidated': json['isIdPortenValidated'] == null ? undefined : json['isIdPortenValidated'],
        'lastLoggedInOn': json['lastLoggedInOn'] === undefined ? undefined : json['lastLoggedInOn'] === null ? null : (new Date(json['lastLoggedInOn'])),
        'userAliases': json['userAliases'] === undefined ? undefined : json['userAliases'] === null ? null : ((json['userAliases'] as Array<any>).map(UserAliasResponseFromJSON)),
        'organizationAddress': json['organizationAddress'] === undefined ? undefined : json['organizationAddress'] === null ? null : json['organizationAddress'],
        'organizationForm': json['organizationForm'] === undefined ? undefined : json['organizationForm'] === null ? null : json['organizationForm'],
        'organizationName': json['organizationName'] === undefined ? undefined : json['organizationName'] === null ? null : json['organizationName'],
        'organizationNumber': json['organizationNumber'] === undefined ? undefined : json['organizationNumber'] === null ? null : json['organizationNumber'],
        'organizationPostNumberAndCity': json['organizationPostNumberAndCity'] === undefined ? undefined : json['organizationPostNumberAndCity'] === null ? null : json['organizationPostNumberAndCity'],
        'status': json['status'] == null ? undefined : ExternalUserStatusFromJSON(json['status']),
        'identityProvider': json['identityProvider'] == null ? undefined : UserIdentityProviderFromJSON(json['identityProvider']),
        'userKrrInfo': json['userKrrInfo'] == null ? undefined : UserKrrInfoResponseFromJSON(json['userKrrInfo']),
        'statsforvalterenOrganizationGroup': json['statsforvalterenOrganizationGroup'] == null ? undefined : UserOrganizationGroupResponseFromJSON(json['statsforvalterenOrganizationGroup']),
    };
}

export function ExternalUserDetailResponseToJSON(json: any): ExternalUserDetailResponse {
    return ExternalUserDetailResponseToJSONTyped(json, false);
}

export function ExternalUserDetailResponseToJSONTyped(value?: ExternalUserDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'firstName': value['firstName'],
        'surname': value['surname'],
        'displayName': value['displayName'],
        'email': value['email'],
        'mfaPhoneNumber': value['mfaPhoneNumber'],
        'isIdPortenUser': value['isIdPortenUser'],
        'isIdPortenValidated': value['isIdPortenValidated'],
        'lastLoggedInOn': value['lastLoggedInOn'] == null ? value['lastLoggedInOn'] : value['lastLoggedInOn'].toISOString(),
        'userAliases': value['userAliases'] == null ? undefined : ((value['userAliases'] as Array<any>).map(UserAliasResponseToJSON)),
        'organizationAddress': value['organizationAddress'],
        'organizationForm': value['organizationForm'],
        'organizationName': value['organizationName'],
        'organizationNumber': value['organizationNumber'],
        'organizationPostNumberAndCity': value['organizationPostNumberAndCity'],
        'status': ExternalUserStatusToJSON(value['status']),
        'identityProvider': UserIdentityProviderToJSON(value['identityProvider']),
        'userKrrInfo': UserKrrInfoResponseToJSON(value['userKrrInfo']),
        'statsforvalterenOrganizationGroup': UserOrganizationGroupResponseToJSON(value['statsforvalterenOrganizationGroup']),
    };
}

